import {useEffect,} from 'react';

import {useMeters} from '../hooks/useMeters.ts';
import {Meter} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";

export const MetersAutocomplete = (props: FieldProps & TextInputProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {
        items: records,
        loading,
        fetchRecords
    } = useMeters();


    useEffect(() => {
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (

        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: Meter) => `${record.name}`}
            getSelectedOption={(record: Meter) => `${record.name}`}
            isLoading={loading}
            {...props}
        />

    );
};